function CustomerForm({ customer, setCustomer,
    phone, setPhone,
    address,setAddress,
    gstin, setGstin,
    state, setState,
    city, setCity
 }) {
  return (
    <div className="card">
      <h3>Customer</h3>

      <input
        placeholder="Customer Name"
        value={customer}
        onChange={(e) => setCustomer(e.target.value)}
      />
      <input 
      placeholder="Phone"
      value={phone}
      onChange={(e) => setPhone(e.target.value)}/>
      <input 
      placeholder="Address"
      value={address}
      onChange={(e) => setAddress(e.target.value)}/>
      <input
  type="text"
  placeholder="State"
  value={state}
  onChange={(e) => setState(e.target.value)}
  
/>
<input
  type="text"
  placeholder="City"
  value={city}
  onChange={(e) => setCity(e.target.value)}
/>
      <input
      placeholder="GstIn"
      value={gstin}
      onChange={(e) => setGstin(e.target.value)}/>
    </div>
  );
}

export default CustomerForm;